export {
  PolicyPaymentModule,
  routepolicypayment,
  øPolicyPaymentModule,
} from './policy-payment.module';
export { StarterService } from './starter.service';
